import { z } from "zod";

export const PaymentFrequencySchema = z.enum([
  "MONTHLY",
  "WEEKLY",
  "BIWEEKLY",
  "QUARTERLY",
  "ANNUALLY",
  "BIANNUALLY",
  "ONE_TIME",
  "OTHER",
]);
